import { DATE_FORMATS, formatDate } from 'utils/dates'

import { useUser } from 'contexts/user'

const CommitmentDetails = () => {
  const { user } = useUser()

  const { commitmentDetails } = user
  if (!('commitmentWeeks' in commitmentDetails)) {
    return null
  }

  const { commitmentDurationDate, commitmentWeeks, weeksRemaining } =
    commitmentDetails
  const weeksOrdered = commitmentWeeks - weeksRemaining

  return (
    <div className="md:px-4">
      <h2 className="mb-6 text-k/28_130">Meal Delivery Fulfillment</h2>
      <div className="rounded-lg bg-grey-2 px-6 py-4">
        <div className="text-k/18_120">
          Fulfill by{' '}
          {formatDate(commitmentDurationDate, {
            format: DATE_FORMATS.MONTH_FULL_DAY_YEAR_FULL,
          })}
        </div>
        <div className="text-k/14_120">
          {weeksOrdered} of {commitmentWeeks} meal deliveries ordered
        </div>
      </div>
    </div>
  )
}

export default CommitmentDetails
